import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { dyn, dynStyle } from "trader.ts/ui";
import * as FA from "../../styles/fontawesome.css.classes";

export function renderBehindToggle(
  showingS: Source<boolean>,
  title: string,
  contents: HTMLElement | HTMLElement[],
): HTMLElement {
  return (
    <section>
      <h1
        onclick={() => showingS.set(!showingS.get())}
        style="cursor: pointer;"
      >
        {dynStyle(
          showingS,
          (showing) =>
            showing ? "" : "transform: rotate(-90deg); top: 0px; left: 2px",
          <i className={FA.icon_chevron_circle_down_solid}></i>,
        )}
        {title}
      </h1>
      {dyn(showingS, function (showing) {
        if (showing) {
          return contents;
        } else {
          return <span></span>;
        }
      })}
    </section>
  );
}
